import React from "react";

import "../../GlobalCss/SPF/BillingInvoiceUploadFileTable.css"
import { useState, useEffect } from "react";
import { Form, Input, Popconfirm,Upload, Table, Typography, Button, message, Spin, Image, DatePicker, Tooltip } from 'antd';
import {
    DeleteOutlined, ReloadOutlined, LoadingOutlined, UploadOutlined, PlusOutlined, ExclamationCircleOutlined,
    SearchOutlined
} from "@ant-design/icons";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
import { BaseUrl, FormConfig, JsonConfig, jwtToken } from "../../Repository/BaseRepository";
import axios from "axios";
import { getBillingInvoiceUploadFileData, downloadBillingInvoiceUploadFile, refreshBillingInvoiceUploadFileData, downloadUnmatchedXL  } from "../../Repository/BillingRepository";
import { GetActiveListLastUploadedDate } from "../../Repository/HealthInsuranceRepository";
import moment from "moment";
import Cookies from "js-cookie";
const BillingInvoiceUploadFileTable = () => {
    const [form] = Form.useForm();
    const [griddata, setGriddata] = useState([])
    const [tableLoader, setTableLoader] = useState(false)
    const [editingKey, setEditingKey] = useState('');
    const [rowData, setRowData] = useState([]);
    const [searchRow, setSearchRow] = useState("")
    const [syncSpin, setSyncSpin] = useState(false)
     const [activeList, setActiveList] = useState([]);
       const [activitySpin, setActivitySpin] = useState(false);
       const [dateList, setDateList] = useState(null);
        const [loader, setLoader] = useState(false)
          const [unmatched, setUnmatched] = useState([])
            const [umUploader, setUmUploader] = useState("")
              const [umSpin, setUmSpin] = useState(false)
    const isEditing = (record) => record.ID === editingKey;
const userLogin=Cookies.get("UserLogin")
    useEffect(() => {
        callGriddata();
    }, [])
    const callGriddata = async () => {
        try {
            setTableLoader(true)
            const res = await getBillingInvoiceUploadFileData(); //change
            if (res !== null && res.length > 0) {
                setGriddata(res)
            }
            setTableLoader(false)
        }
        catch {
            ErrorMessage("Cannot able to get data")
        }
    }
    
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const filterProps = () => ({
        filteredValue: [searchRow],
        onFilter: (value, record) => {
            return (
                String(record.Client_Name)
                    .toLowerCase()
                    .includes(String(value).toLowerCase()) ||
                String(record.Portal_Name)
                    .toLowerCase()
                    .includes(String(value).toLowerCase())
            );
        },
    });
    const columns = [
        {
            title: 'Line Number',
            key: 'Line_Num',
            dataIndex: 'LineNum',
            width: 150,
            editable: true,
            ellipsis: true,
            ...filterProps(),
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'Personnelnumber',
            key: 'Personnelnumber',
            dataIndex: 'Personnelnumber',
            width: 150,
            editable: true
        },
        {
            title: 'WeekEnddate',
            key: 'WeekEnddate',
            dataIndex: 'WeekEnddate',
            width: 150,
            editable: true,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'Transdate',
            key: 'Transdate',
            dataIndex: 'Transdate',
            width: 150,
            editable: true
        },
        {
            title: 'ExpenseType',
            key: 'ExpenseType',
            dataIndex: 'ExpenseType',
            width: 150,
            editable: true
        },
        {
            title: 'Rate',
            key: 'Rate',
            dataIndex: 'Rate',
            width: 150,
            editable: true
        },
        {
            title: 'Hour',
            key: 'Hour',
            dataIndex: 'Hour',
            width: 150,
            editable: true
        },
        {
            title: 'Notes',
            key: 'Notes',
            dataIndex: 'Notes',
            width: 200,
            editable: true,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'ClientInvoiceRef',
            key: 'ClientInvoiceRef',
            dataIndex: 'ClientInvoiceRef',
            width: 150,
            editable: true
        },
        {
            title: 'Txt',
            key: 'Txt',
            dataIndex: 'Txt',
            width: 150,
            editable: true,
            ellipsis: true,
            render: (text, record, index) => (
                <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
            )
        },
        {
            title: 'JournalLineType',
            key: 'JournalLineType',
            dataIndex: 'JournalLineType',
            width: 150,
            editable: true
        },
        // {
        //     title: 'ACTION',
        //     dataIndex: 'action',
        //     fixed: 'right',
        //     width: 100,
        //     render: (_, record) => {
        //         const editable = isEditing(record);
        //         return editable ? (
        //             <span>
        //                 <Popconfirm title="Sure to save?" onConfirm={() => editTableRowData(record)}
        //                     onCancel={cancel}>
        //                     <Typography.Link
        //                         style={{
        //                             marginRight: 8,
        //                         }}
        //                     >
        //                         <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
        //                     </Typography.Link>
        //                 </Popconfirm>
        //                 <Typography.Link onClick={() => cancel()}>
        //                     <CloseOutlined style={{ color: "red" }} />
        //                 </Typography.Link>

        //             </span>
        //         ) : (
        //             <div>
        //                 <Typography.Link onClick={() => edit(record)} disabled={editingKey !== ''} >
        //                     <Image
        //                         src="./Images/editicon.svg"
        //                         style={{
        //                             border: "none",
        //                             width: "100% ",
        //                             marginRight: 5
        //                         }}
        //                         showPreviewIcon={false}
        //                         preview={false}
        //                     />
        //                 </Typography.Link>
        //             </div>
        //         );
        //     },
        // },
    ]
    const cancel = () => {
        setEditingKey("");
    }
    const edit = (record) => {
        setRowData(record)
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.ID);
    }
    const compareObjects = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) {
            return false;
        }
        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
        return true;
    };
    const compareLists = (rowData, currentRowData) => {
        if (typeof rowData !== 'object' || typeof currentRowData !== 'object') {
            return false;
        }
        const result = compareObjects(rowData, currentRowData);
        return result;
    };
    function formatDateToYYYYMMDD(date) {
        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    // const editTableRowData = async (props) => {
    //     try {
    //         const currentRowData = await form.getFieldValue();
    //         const comparision = compareLists(rowData, currentRowData);
    //         if (comparision === false) {
    //             const data = {
    //                 "id": currentRowData.ID,
    //                 "vms": "",
    //                 "client_Name": currentRowData.Client_Name,
    //                 "weekend_Date": formatDateToYYYYMMDD(currentRowData.Weekend_Date),
    //                 // "weekend_Date": currentRowData.Weekend_Date,
    //                 "portal_Name": currentRowData.Portal_Name,
    //                 "rT_Hours": currentRowData.RT_Hours,
    //                 "oT_Hours": currentRowData.OT_Hours,
    //                 "dT_Hours": currentRowData.DT_Hours,
    //                 "rT_BillRate": currentRowData.RT_BillRate,
    //                 "oT_BillRate": currentRowData.OT_BillRate,
    //                 "dT_BillRate": currentRowData.DT_BillRate,
    //                 "approved_Status": currentRowData.Approved_Status,
    //                 "downloadDate": "2024-07-29T13:24:09.656Z"
    //             }
    //             const updateresponse = await updateBillingMFRow(data)
    //             if (updateresponse.data.statusCode === 200) {
    //                 const res = await getBillingMfData()
    //                 if (res !== null && res.length > 0) {
    //                     setGriddata(res)
    //                 }
    //                 SuccessMessage(updateresponse.data.message)
    //             }
    //             else if (updateresponse.data.statusCode === 500) {
    //                 InfoMessage(updateresponse.data.message)
    //             }
    //             else {
    //                 ErrorMessage("Cannot able to update, please try again")
    //             }
    //             setEditingKey("");
    //         }
    //         else {
    //             InfoMessage("No changes made. Edit and try again.")
    //         }
    //     }
    //     catch (err) {
    //         return err
    //     }
    // }
     useEffect(() => {
        fetchData();
       
      }, []);
    
      
    
      const fetchData = async () => {
        try {
          const response = await GetActiveListLastUploadedDate();
          console.log(response);
          if (response && response.payload) {
            const payloadObject = JSON.parse(response.payload);
            setDateList(payloadObject);
            console.log(payloadObject);
          }
        } catch (err) {
          console.log(err);
        }
      };
    const downloadBillingMSfile = async () => { //change
        try {
            const resp = await downloadBillingInvoiceUploadFile(griddata) // change
            if (resp === "downloaded") {
                SuccessMessage("Downloaded successfully !!")
            }
        }
        catch {
            ErrorMessage("Cannot able to download, please try again")
        }
    }
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const refreshDataMethod = async () => { 
        try {
            setSyncSpin(true)
            setTableLoader(true)
            const res = await refreshBillingInvoiceUploadFileData(); //change
            if (res !== null && res.length > 0) {
                setGriddata(res)
            }
            setSyncSpin(false)
            setTableLoader(false)
        }
        catch {
            setSyncSpin(false)
            setTableLoader(false)
        }
    }
    const handleActivelistUpload = async (options) => {
        try {
          setActivitySpin(true);
          const { file, onSuccess, onError } = options;
          const updatedDeductionFile = { file, status: "uploading" };
          
          const formData = new FormData();
          formData.append("File", file);
    
          const response = await axios.post(
            `${BaseUrl}Billing/upload_workerlist?Username=${encodeURIComponent(
              userLogin
            )}`,
            formData,
            FormConfig
          );
          if (response.data && response.data.statusCode === 200) {
            onSuccess(file);
            SuccessMessage("File uploaded successfully");
            updatedDeductionFile.status = "done";
            setActiveList([updatedDeductionFile]);
            setActivitySpin(false);
            fetchData(); 
          } else {
            onError(file);
            ErrorMessage(response.data.message || "File upload failed");
            updatedDeductionFile.status = "error";
            setActiveList([updatedDeductionFile]);
            setActivitySpin(false);
          }
        } catch (error) {
          message.error(`File upload failed`);
          setActivitySpin(false);
        }
      };
      const itemActiveListRender = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
          statusColor = "green";
        } else if (file.status === "error") {
          statusColor = "#f55451";
        }
        let fileExists = false;
        if (activeList.length > 0) {
          fileExists = true;
        }
        return (
          <>
            <div style={{ display: "flex", alignItems: "center", height: "auto" }}>
              <div
                style={{
                  color: statusColor,
                  width: "40%",
                  height: "auto",
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "2px",
                  marginLeft:"25px",
                  borderRadius: "4px",
                }}
              >
                {fileExists ? activeList[0].file.name : null}
              </div>
              <DeleteOutlined
                style={{ marginTop: "2px" }}
                onClick={() => setActiveList([])}
              />
            </div>
          </>
        );
      };
      const handleUnmatchedUpload = async (options) => {
        try {
            setUmSpin(true);
            const { file, onSuccess, onError } = options;
            console.log("Uploading File:", file); // Debugging
    
            const formData = new FormData();
            formData.append("unMatchedFile", file);
    
            console.log("Form Data:", formData.get("unMatchedFile")); // Debugging
    
            setUnmatched([]);
            setUmUploader(file.name);
    
            const response = await axios.post(
                `${BaseUrl}Billing/UploadUnMatchedData`,
                formData,
                FormConfig
            );
    
            console.log("API Response:", response); // Debugging
    
            if (response.data.statusCode === 200) {
                onSuccess(file);
                message.success(`File uploaded successfully`);
                setUnmatched([{ file, status: "done" }]);
            } else if (response.data.statusCode === 204) {
                onError(new Error(response.data.message));
                message.info(response.data.message);
                setUnmatched([{ file, status: "error" }]);
            } else {
                onError(new Error("Upload failed"));
                message.error(response.data.message);
                setUnmatched([{ file, status: "error" }]);
            }
        } catch (error) {
            console.error("File upload error:", error); // Log error details
            message.error(`File upload failed: ${error.message}`);
        } finally {
            setUmUploader("");
            setUmSpin(false);
        }
    };
    
    const itemRenderUnmatched = (originNode, file) => {
        let statusColor;
        if (file.status === "done") {
            statusColor = "green";
        } else if (file.status === "error") {
            statusColor = "#f55451";
        }
        let fileExists = false;
        if (unmatched.length > 0) {
            fileExists = true;
        }
    }
   const downloadList = async () => {
        try {
            setLoader(true)
            const response = await downloadUnmatchedXL();
            setLoader(false)
        }
        catch {
            setLoader(false)
        }
    }

    return (<>
        <div style={{ margin: 20 }}>
            <div style={{ marginBottom: 50 }} className="billingmf-div">
                <div style={{ width:"50%", display: "flex" }}>
                    <Input
                        placeholder="Search Portal Name \ Client Name"
                        className="MFbilling-searchrow"
                        // style={{ borderColor: "#3B52DF", color: "#3B52DF" }}
                        onChange={(e) => setSearchRow(e.target.value)}
                        allowClear
                        suffix={
                            <SearchOutlined
                                style={{ color: "#7185FF", justifyContent: "space-between" }}
                            />
                        }
                    />
                    <div className="refresh-class">
                        {syncSpin ?
                            <Spin indicator={<ReloadOutlined style={{ fontSize: 30, marginLeft: 10, color: "#3B52DF" }} spin />} /> :
                            <Tooltip title={
                                <span
                                    className="placeholder-span"
                                    style={{ color: "#ffff" }}
                                >
                                    Refresh data
                                </span>
                            } color={"#108ee9"} key={"#108ee9"}>
                                <ReloadOutlined style={{ fontSize: 30, marginLeft: 10, color: "#3B52DF", cursor: "pointer" }}
                                    onClick={refreshDataMethod} /> 
                            </Tooltip>}
                    </div>
                      <div className="activeupload-class" style={{ height: 40,width:"50%" }}>
                              <Upload.Dragger
                                name="file"
                                customRequest={handleActivelistUpload}
                                itemRender={itemActiveListRender}
                                fileList={activeList}
                                accept=".xls,.xlsx"
                                onRemove={() => setActiveList([])}
                                style={{
                                  // border: "1px solid rgba(0, 39, 102, 0.5)",
                                  // boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                  border:"1px dashed #3B52DF",
                                  borderRadius: 10,
                                  marginTop:"5px",
                                  height: "40px",
                                  marginLeft:"20px",
                                  color:"#002766",
                                  width:"250px"
                                }}
                              >
                              
                              <div className="content-file" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <span style={{ color: "#3B52DF",marginLeft:"30px" }}>Upload Active list</span>
                            <UploadOutlined
                              style={{
                                color: "#3B52DF",
                                fontSize: 17,
                                marginLeft: "10px",
                              }}
                            />
                          </div>
                          {activitySpin && (
                            <div className="xxl-spinner" style={{ marginLeft: "10px",marginRight:"10px" }}>
                              <Spin size="medium" />
                            </div>
                          )}
                        </div>
                                
                              </Upload.Dragger>
                              
                              {/* <p style={{marginLeft:"25px",fontSize:"14px",fontFamily:"open sans",color:"#7185FF",width:"500px"}}> 
                                Last Uploaded Date:
                                {dateList &&
                                  dateList.HealthInsurancepaychexDate &&
                                  moment.utc(dateList.HealthInsurancepaychexDate).tz('Asia/Kolkata').format(
                                    "MM/DD/YYYY HH:mm:ss"
                                  )}
                              </p> */}
                              
                            </div>
                          
                           
                       
                </div>
               <div style={{display:"flex",flexDirection:"row",marginRight:"30px"}}>
               <div className="unmatched-download" style={{marginRight:"10px"}}>
                                 <Button className="sync-button-enable" onClick={downloadList} loading={loader}>
                                                                Unmatched list download</Button>
                        </div>
                            {/* <div className="unmatchedfile-upload">
                                <Upload
                                    className="unmatched-upload-file"
                                    name="file"
                                    customRequest={handleUnmatchedUpload}
                                    itemRender={itemRenderUnmatched}
                                    fileList={unmatched}
                                    accept=".xls,.xlsx"
                                    onRemove={() => setUnmatched([])}
                                    style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}
                                >
                                    <div className='unmatched-content-file'>
                                        <span className="hrfile-name">Upload Unmatched list</span>
                                        {umSpin ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7 }} spin />} />
                                            : <Image src="./Images/uploadimg.png"
                                                style={{
                                                    border: "none",
                                                    width: 19,
                                                    height: 17,
                                                }}
                                                showPreviewIcon={false}
                                                preview={false} />}
                                    </div>
                                </Upload>
                                {umUploader.length > 0 ? <div style={{ width: 'fit-content', maxWidth: 200, wordBreak: 'break-all', marginBottom: 2, color: "rgba(0, 39, 102, 1)" }}>{umUploader}</div> : null}
                            </div> */}
               </div>
                <div style={{ display: "flex", alignItems: "center", }}>
                    <Button onClick={downloadBillingMSfile} className="dwld-invoice">Download .CSV</Button> 
                </div>
            </div>
            <div className={griddata.length > 0 ? "ten99-table-class" : "ten99-empty-table"}>
                {
                    tableLoader ?
                        <Spin tip="Loading...">
                            <Form form={form} component={false}>
                                <Table
                                    className="ten99-table"
                                    rowClassName="editable-row"
                                    columns={mergedColumns}
                                    dataSource={griddata}
                                    components={{ body: { cell: EditableCell, }, }}
                                    bordered
                                    scroll={{ x: "max-content" , y: 400}}
                                // pagination
                                /> </Form> </Spin> :
                        griddata.length > 0 ? < Form form={form} component={false} >
                            <Table
                                className="ten99-table"
                                rowClassName="editable-row"
                                columns={mergedColumns}
                                dataSource={griddata}
                                components={{ body: { cell: EditableCell, }, }}
                                bordered
                                scroll={{ x: 1500, y: 400 }}
                            />
                        </Form> : < Form form={form} component={false} >
                            <Table
                                className="ten99-table"
                                rowClassName="editable-row"
                                columns={mergedColumns}
                                dataSource={griddata}
                                components={{ body: { cell: EditableCell, }, }}
                                bordered
                                scroll={{ x: 400, y: 400 }}
                            />
                        </Form>
                }
            </div>
        </div>
    </>)
}
export default BillingInvoiceUploadFileTable;